import React from "react";
import Wrp from '../../../hoc/Wrp/Wrp';
// import ComposeMail from './UI/ComposeMail';
import MainMenu from './UI/MainMenu';
// import BulkEmail from './UI/BulkEmail';

const mailLeftNav = (props) => {
	
	return(
        <Wrp>
		<div className="toggled border-right email-wrapper wrapper d-none d-sm-none d-md-block" style={{}}> 
            <div className="filter_Box no-bd crmEmail" style={{"width":"160px"}}>
                <div className="filter_Body  bg-white p-2">
                    <div className="mail-sidebar ">
                        <div className="menu-bar">
                            {/*<ComposeMail {...props} toggleModelHandler={props.toggleModelHandler}/>*/}
                            <MainMenu 
                            {...props} 
                            tableRecords={props.tableRecords}
                            />
                            {/*<BulkEmail />*/}
                        </div>     
                    </div>
                </div>                       
            </div>
        </div>
        {
            props.isMobileWebMenu === true ?
            <div className={props.isMobileWebMenu === true ? '' : "hide"}>
                <span className="mt-0 p-0 dropdown-menu show dropdown-menu-left dropdownmenu-content" style={{"top": '0', 'width': '230px', 'height': '100%'}}>
                    <div className="clearfix">
                        <div className="card-header p-1">
                            <div className="d-flex">                                             
                                <h6 className="p-2"> Menu </h6>                                      
                                <a onClick={props.toggleMobileWebMenu} className="icon-right cursor-pointer"><i className="fas fa-times-circle secondary_color"></i></a>
                            </div>
                        </div>
                        <div className="card-body pt-0 pb-0 fixedHeight">                            
                            {/*<ComposeMail {...props} toggleModelHandler={props.toggleModelHandler}/>*/}
                            <MainMenu 
                            {...props} 
                            tableRecords={props.tableRecords}
                            />
                            {/*<BulkEmail />*/}                             
                        </div>
                    </div>
                </span>
            </div>
            :
            null
        }
        </Wrp>
	)
} 

export default mailLeftNav;